var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.065,
    height: 36.065,
    viewBox: "0 0 36.065 36.065",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Instagram",
    transform: "translate(-809.925 -150.693)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_327",
    "data-name": "Rectangle 327",
    width: 36.065,
    height: 36.065,
    rx: 9.128,
    transform: "translate(809.925 150.693)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M833.487,162.048a1.224,1.224,0,1,0,1.224,1.225A1.225,1.225,0,0,0,833.487,162.048Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M828.043,163.618a5.144,5.144,0,1,0,5.144,5.144A5.149,5.149,0,0,0,828.043,163.618Zm0,8.439a3.3,3.3,0,1,1,3.295-3.3A3.3,3.3,0,0,1,828.043,172.057Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M832.127,179.205h-8.339a6.281,6.281,0,0,1-6.273-6.274v-8.339a6.28,6.28,0,0,1,6.273-6.273h8.339a6.28,6.28,0,0,1,6.273,6.273v8.339A6.281,6.281,0,0,1,832.127,179.205Zm-8.339-18.921a4.313,4.313,0,0,0-4.309,4.308v8.339a4.314,4.314,0,0,0,4.309,4.309h8.339a4.314,4.314,0,0,0,4.308-4.309v-8.339a4.313,4.313,0,0,0-4.308-4.308Z",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.223b99292bc3f25d221118d5aff9ee9c.svg";
export { ForwardRef as ReactComponent };